import { Security } from "../../../openapi/security"

export type SecurityState = {
    searchDone: boolean
    securities?: Security[]
    securitiesSearchCriteria?: FormData    
    secWindowHistoryState?: Object
    error? : string    
}

export  type SecurityAction =
    | {
      type: "Security/SEARCHDONE",
      payload: Security[],   
      searchCriteria: FormData         
    }
    | {
        type: "Security/RESETSEARCH"        
    }
    | {
        type: "Security/FETCHERROR",
        payload: string
    }
    | {
        type: "SecurityResult/SAVEHISTORY",
        windowHistoryState: Object
    }
  
    const initialState: SecurityState = { searchDone: false }


export    const securityResultReducer = (
        state: SecurityState = initialState,
        action: SecurityAction 
    ) => {        
        switch (action.type) {
            case "Security/SEARCHDONE":
              return { ...state,  searchDone: true, securities: action.payload, securitiesSearchCriteria: action.searchCriteria}
            case "Security/RESETSEARCH" : {
                return { ...state,  searchDone: false }
            }
            case "Security/FETCHERROR" : {
                return { ...state,  searchDone: false, error: action.payload }
            }
            case "SecurityResult/SAVEHISTORY" : {
                return { ...state, secWindowHistoryState: action.windowHistoryState}
            }            

            default: return state
        }
    }
    